stimulusApp.register(
  "fold",
  class extends Stimulus.Controller {
    static targets = ["list", "toggle"]

    toggle() {
      this.toggleTarget.setAttribute("aria-expanded", !this.#expanded)
      this.#sort()
    }

    resync() {
      if (this.#expanded) this.#sort()
    }

    get #expanded() {
      return this.toggleTarget.getAttribute("aria-expanded") === "true"
    }

    #sort() {
      const order = this.#expanded ? "expandedOrder" : "collapsedOrder"
      const items = [...this.listTarget.children]
      items.sort((a, b) => a.dataset[order] - b.dataset[order])
      this.listTarget.append(...items)
    }
  },
)
